import { render, staticRenderFns } from "./ListaEspera.vue?vue&type=template&id=c8db910a&scoped=true"
import script from "./ListaEspera.vue?vue&type=script&lang=js"
export * from "./ListaEspera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8db910a",
  null
  
)

export default component.exports